exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-item[data-v-41d9230c]{min-height:30px}.nav-item .nav-item-link[data-v-41d9230c]{padding:9px 10px;display:inline-block;width:100%;cursor:pointer;color:rgba(0,0,0,.85);transition:background .1s;text-transform:uppercase;text-decoration:none;font-weight:700}.nav-item .nav-item-link[data-v-41d9230c]:hover{background:#d7e0e8;text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-41d9230c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/nav/private/SubItem.vue
// module id = 579d1cda1cb4ca605c7e
// module chunks = 0